import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { LoginService } from '../shared/user-login/login.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(public loginService : LoginService,private router : Router){}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
      if (!this.loginService.isLoggedIn()) {
        this.router.navigateByUrl('/signin');
        this.loginService.deleteToken();
        return false;
      }
    return true;
  }

}
